<!-- src/components/data/HistoricalChart.vue - VERSIONE CORRETTA -->
<!-- <template>
  <div class="historical-chart">
    <div v-if="loading" class="chart-loading">
      <div class="spinner"></div>
      Caricamento grafico...
    </div>

    <div v-else-if="!processedData.length" class="chart-empty">
      Nessun dato disponibile per il periodo selezionato
    </div>

    <div v-else class="chart-container">
      <canvas ref="chartCanvas"></canvas>
    </div>

    <div v-if="processedData.length" class="chart-info">
      <div class="info-item">
        <span class="info-label">Metrica:</span>
        <span class="info-value">{{ getMetricLabel(metric) }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Periodo:</span>
        <span class="info-value">{{ getRangeLabel(range) }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Dati disponibili:</span>
        <span class="info-value">{{ processedData.length }} punti</span>
      </div>
    </div>
  </div>
</template> -->

<!-- <script setup lang="ts">
import {
  ref,
  onMounted,
  watch,
  onBeforeUnmount,
  nextTick,
  computed,
} from "vue";
import { Chart, ChartConfiguration, ChartOptions } from "chart.js/auto";

const props = defineProps<{
  metric: string;
  range: string;
  data: any[];
  loading: boolean;
  vin?: string;
}>();

const chartCanvas = ref<HTMLCanvasElement>();
const chartInstance = ref<Chart | null>(null);

// CRITICO: Crea una versione SEMPLIFICATA e NON-REATTIVA dei dati
const processedData = computed(() => {
  // console.log("props.data", props.data);
  // console.log("props.metric", props.metric);
  if (!props.data?.length) return [];

  try {
    // 1. Estrai solo i campi necessari
    const simplifiedData = props.data.map((item) => ({
      timestamp:
        typeof item.timestamp === "string"
          ? parseInt(item.timestamp, 10)
          : item.timestamp,
      vehicle_speed: item.vehicle_speed ?? 0,
      engine_rpm: item.engine_rpm ?? 0,
      engine_temperature: item.engine_temperature ?? 0,
      fuel_level: item.fuel_level ?? 0,
      engine_load: item.engine_load ?? 0,
      tracker_battery: item.tracker_battery ?? 0,
    }));

    // ORDINA per timestamp ASCENDENTE (dal vecchio al nuovo per il grafico)
    const sortedData = [...simplifiedData].sort((a, b) => a.timestamp - b.timestamp);
    
    // console.log("📊 [HistoricalChart] Timestamp range:", {
    //   first: sortedData[0]?.timestamp ? new Date(sortedData[0].timestamp * 1000).toISOString() : 'N/A',
    //   last: sortedData[sortedData.length - 1]?.timestamp ? new Date(sortedData[sortedData.length - 1].timestamp * 1000).toISOString() : 'N/A',
    //   count: sortedData.length
    // });

    return sortedData;

    // // 2. Filtra per range se necessario (i tuoi dati sono del 2024, quindi mostra tutto)
    // const now = Math.floor(Date.now() / 1000);
    // const oneYearAgo = now - 365 * 24 * 60 * 60;

    // // Se i dati sono vecchi (>1 anno), mostra tutto
    // const firstTimestamp = simplifiedData[0]?.timestamp;
    // if (firstTimestamp && firstTimestamp < oneYearAgo) {
    //   return simplifiedData;
    // }

    // // Altrimenti filtra per range
    // let cutoffSeconds = 0;
    // switch (props.range) {
    //   case "1h":
    //     cutoffSeconds = 60 * 60;
    //     break;
    //   case "24h":
    //     cutoffSeconds = 24 * 60 * 60;
    //     break;
    //   case "7d":
    //     cutoffSeconds = 7 * 24 * 60 * 60;
    //     break;
    //   case "30d":
    //     cutoffSeconds = 30 * 24 * 60 * 60;
    //     break;
    //   default:
    //     return simplifiedData;
    // }

    // const cutoffTime = now - cutoffSeconds;
    // return simplifiedData.filter((item) => item.timestamp >= cutoffTime);
  } catch (error) {
    console.error("❌ [HistoricalChart] Error processing data:", error);
    return [];
  }
});

// Watch per aggiornare i dati
watch(
  () => processedData.value,
  (newData) => {
    // console.log("📊 [HistoricalChart] Processed data updated:", {
    //   length: newData?.length,
    //   metric: props.metric,
    //   range: props.range,
    // });

    if (newData?.length) {
      nextTick(() => {
        updateChart();
      });
    } else {
      if (chartInstance.value) {
        chartInstance.value.destroy();
        chartInstance.value = null;
      }
    }
  },
  { deep: false }
); // IMPORTANTE: deep: false per evitare loop

// Watch per metric
watch(
  () => props.metric,
  () => {
    if (processedData.value.length) {
      updateChart();
    }
  }
);

// Watch per range
watch(
  () => props.range,
  () => {
    if (processedData.value.length) {
      updateChart();
    }
  }
);

function getRangeLabel(range: string) {
  switch (range) {
    case "1h":
      return "Ultima ora";
    case "24h":
      return "Ultime 24 ore";
    case "7d":
      return "Ultimi 7 giorni";
    case "30d":
      return "Ultimi 30 giorni";
    default:
      return range;
  }
}

function getMetricLabel(metric: string) {
  switch (metric) {
    case "speed":
      return "Velocità (km/h)";
    case "rpm":
      return "RPM Motore";
    case "temperature":
      return "Temperatura (°C)";
    case "fuel":
      return "Carburante (%)";
    case "load":
      return "Carico Motore (%)";
    case "battery":
      return "Tensione Batteria (V)";
    default:
      return metric;
  }
}

// function getMetricValue(item: any, metric: string): number {
//   switch (metric) {
//     case "speed":
//       return item.vehicle_speed || 0;
//     case "rpm":
//       return item.engine_rpm || 0;
//     case "temperature":
//       return item.engine_temperature || 0;
//     case "fuel":
//       return item.fuel_level || 0;
//     case "load":
//       return item.engine_load || 0;
//     case "battery":
//       return item.tracker_battery || 0;
//     default:
//       return 0;
//   }
// }
function getMetricValue(item: any, metric: string): number {
  const value = item[getMetricFieldName(metric)];
  
  // PER VELOCITÀ: se null o undefined, mostra 0 (veicolo fermo)
  if ((value === null || value === undefined) && metric === "speed") {
    return 0;
  }
  
  return value || 0;
}

function getMetricFieldName(metric: string): string {
  const map: any = {
    speed: "vehicle_speed",
    rpm: "engine_rpm",
    temperature: "engine_temperature",
    fuel: "fuel_level",
    load: "engine_load",
    battery: "tracker_battery",
  };
  return map[metric] || "vehicle_speed";
}

function formatTimestamp(timestamp: number, range: string): string {
  if (!timestamp) return "";

  const date = new Date(timestamp * 1000);
  
  // Se i dati sono di ANNI diversi (es. 2025 vs 2026), mostra sempre data completa
  const now = new Date();
  const isDifferentYear = date.getFullYear() !== now.getFullYear();
  
  if (isDifferentYear || range === "7d" || range === "30d") {
    return date.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit"
    });
  } else if (range === "24h") {
    return date.toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  } else {
    // 1h
    return date.toLocaleTimeString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
    });
  }
}

function updateChart() {
  if (!chartCanvas.value || !processedData.value.length) {
    console.log("❌ [HistoricalChart] Cannot update chart - no canvas or data");
    return;
  }

  try {
    // Distruggi il grafico esistente
    if (chartInstance.value) {
      chartInstance.value.destroy();
      chartInstance.value = null;
    }

    // Prepara i dati
    const labels = processedData.value.map((item) =>
      formatTimestamp(item.timestamp, props.range)
    );

    const dataPoints = processedData.value.map((item) =>
      getMetricValue(item, props.metric)
    );

    console.log("📈 [HistoricalChart] Creating chart with:", {
      labels: labels.length,
      dataPoints: dataPoints.length,
      metric: props.metric,
    });

    const chartDataTimestamps = processedData.value.map(d => d.timestamp * 1000);
    const chartMinTime = Math.min(...chartDataTimestamps);
    const chartMaxTime = Math.max(...chartDataTimestamps);
    
    // Per range "custom", estendi visivamente il range
    let displayMinTime = chartMinTime;
    let displayMaxTime = chartMaxTime;
    
    if (props.range === "custom") {
      // Estendi il range del 10% a sinistra e destra per visibilità
      const timeSpan = chartMaxTime - chartMinTime;
      displayMinTime = chartMinTime - (timeSpan * 0.1);
      displayMaxTime = chartMaxTime + (timeSpan * 0.1);
      
      console.log("📊 [HistoricalChart] Custom range - extending:", {
        dataRange: `${new Date(chartMinTime).toLocaleDateString()} - ${new Date(chartMaxTime).toLocaleDateString()}`,
        displayRange: `${new Date(displayMinTime).toLocaleDateString()} - ${new Date(displayMaxTime).toLocaleDateString()}`
      });
    }

    const chartOptions: ChartOptions<"line"> = {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        duration: 0,
      },
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: true,
          mode: "index",
          intersect: false,
          callbacks: {
            label: function (context) {
              const value = context.raw;
              const label = getMetricLabel(props.metric);
              return `${label}: ${value}`;
            },
          },
        },
      },
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: "Tempo",
          },
          grid: {
            display: false,
          },
          ticks: {
            maxTicksLimit: 10,
            autoSkip: true,
          },
        },
        y: {
          display: true,
          title: {
            display: true,
            text: getMetricLabel(props.metric),
          },
          beginAtZero: props.metric !== "temperature",
          grid: {
            color: "rgba(255, 255, 255, 0.1)",
          },
        },
      },
      interaction: {
        intersect: false,
        mode: "index", // Ora TypeScript riconosce il tipo corretto
      },
    };

    const chartConfig: ChartConfiguration<"line"> = {
      type: "line",
      data: {
        labels,
        datasets: [
          {
            label: getMetricLabel(props.metric),
            data: dataPoints,
            borderColor: "#4caf50",
            backgroundColor: "rgba(76, 175, 80, 0.1)",
            borderWidth: 2,
            fill: true,
            tension: 0.4,
            pointRadius: 2,
            pointBackgroundColor: "#4caf50",
          },
        ],
      },
      options: chartOptions,
    };

    // Crea il nuovo grafico
    chartInstance.value = new Chart(chartCanvas.value, chartConfig);

    console.log("✅ [HistoricalChart] Chart created successfully");
  } catch (error) {
    console.error("❌ [HistoricalChart] Error creating chart:", error);
    // Fallback: mostra messaggio di errore
    if (chartCanvas.value) {
      const ctx = chartCanvas.value.getContext("2d");
      if (ctx) {
        ctx.fillStyle = "#ff6b6b";
        ctx.font = "14px Arial";
        ctx.fillText("Errore nel caricamento del grafico", 10, 50);
      }
    }
  }
}

onMounted(() => {
  console.log("📊 [HistoricalChart] Component mounted");

  if (processedData.value.length && chartCanvas.value) {
    nextTick(() => {
      updateChart();
    });
  }
});

onBeforeUnmount(() => {
  console.log("👋 [HistoricalChart] Component unmounting");
  if (chartInstance.value) {
    chartInstance.value.destroy();
    chartInstance.value = null;
  }
});
</script> -->

<!-- <style scoped>
.historical-chart {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  border-radius: 8px;
  overflow: hidden;
}

.chart-loading,
.chart-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #aaa;
  font-size: 16px;
  padding: 40px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #333;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.chart-container {
  flex: 1;
  position: relative;
  padding: 20px;
  min-height: 400px;
}

.chart-info {
  display: flex;
  justify-content: space-around;
  padding: 16px 20px;
  background: #222;
  border-top: 1px solid #333;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.info-label {
  font-size: 12px;
  color: #aaa;
}

.info-value {
  font-size: 14px;
  color: white;
  font-weight: bold;
}
</style> -->


<!-- src/components/data/HistoricalChart.vue -->
<template>
  <div class="historical-chart">
    <!-- Overlay loading (canvas resta sempre montato) -->
    <div v-if="loading" class="chart-loading">
      <div class="spinner"></div>
      Caricamento grafico...
    </div>

    <!-- Canvas container SEMPRE presente -->
    <div class="chart-container" @wheel="handleWheel">
      <canvas ref="chartCanvas"></canvas>

      <!-- Empty state overlay (solo visivo, non smonta canvas) -->
      <div v-if="!loading && !processedSeries.length" class="chart-empty-overlay">
        Nessun dato disponibile per il periodo selezionato
      </div>

      <!-- Hint zoom -->
      <div class="zoom-hint-overlay" :class="{ show: showZoomHint }">
        <div class="zoom-hint-content">
          Usa <kbd>Alt</kbd> + rotella per zoomare
          <span class="hint-sub">Pan: <kbd>Shift</kbd> + drag</span>
        </div>
      </div>
    </div>

    <div v-if="processedSeries.length" class="chart-info">
      <div class="info-item">
        <span class="info-label">Metrica:</span>
        <span class="info-value">{{ getMetricLabel(metric) }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Periodo:</span>
        <span class="info-value">{{ getRangeLabel(range) }}</span>
      </div>
      <div class="info-item">
        <span class="info-label">Dati disponibili:</span>
        <span class="info-value">{{ processedSeries.length }} punti</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {
  ref,
  computed,
  watch,
  onMounted,
  onBeforeUnmount,
  nextTick,
  shallowRef,
  markRaw,
} from "vue";

import "chartjs-adapter-luxon";
import { Chart } from "chart.js/auto";
import zoomPlugin from "chartjs-plugin-zoom";

Chart.register(zoomPlugin);

const props = defineProps<{
  metric: string; // speed|rpm|...
  range: string;  // 1h|24h|7d|30d|custom
  data: any[];
  loading: boolean;
  vin?: string;
  timeRange?: { start: number; end: number } | null;
}>();

const chartCanvas = ref<HTMLCanvasElement | null>(null);
const chartInstance = shallowRef<Chart | null>(null);

// Hint overlay (scroll senza Alt)
const showZoomHint = ref(false);
let hintTimeout: any = null;

function handleWheel(e: WheelEvent) {
  if (!e.altKey) {
    showZoomHint.value = true;
    if (hintTimeout) clearTimeout(hintTimeout);
    hintTimeout = setTimeout(() => (showZoomHint.value = false), 1800);
  } else {
    showZoomHint.value = false;
  }
}

function getMetricFieldName(metric: string): string {
  const map: Record<string, string> = {
    speed: "vehicle_speed",
    rpm: "engine_rpm",
    temperature: "engine_temperature",
    fuel: "fuel_level",
    load: "engine_load",
    battery: "tracker_battery",
  };
  return map[metric] || "vehicle_speed";
}

function getMetricLabel(metric: string) {
  switch (metric) {
    case "speed":
      return "Velocità (km/h)";
    case "rpm":
      return "RPM Motore";
    case "temperature":
      return "Temperatura (°C)";
    case "fuel":
      return "Carburante (%)";
    case "load":
      return "Carico Motore (%)";
    case "battery":
      return "Tensione Batteria (V)";
    default:
      return metric;
  }
}

function getRangeLabel(range: string) {
  switch (range) {
    case "1h":
      return "Ultima ora";
    case "24h":
      return "Ultime 24 ore";
    case "7d":
      return "Ultimi 7 giorni";
    case "30d":
      return "Ultimi 30 giorni";
    case "custom":
      return "Personalizzato";
    default:
      return range;
  }
}

/**
 * Serie {x,y} in ms (timeseries) e PLAIN (no Proxy Vue)
 */
const processedSeries = computed(() => {
  if (!props.data?.length) return [];
  const field = getMetricFieldName(props.metric);

  // console.log("props.data", props.data);
  const series = props.data.map((item: any) => {
    const ts =
      typeof item.timestamp === "string"
        ? parseInt(item.timestamp, 10)
        : Number(item.timestamp);

    const raw = item?.[field];

    // Per speed: null/undefined => 0 (fermo)
    const y =
      (raw === null || raw === undefined)
        ? 0
        : Number(raw ?? 0);
    // const y = (raw === null || raw === undefined) ? null : Number(raw);

    return { x: ts * 1000, y };
  });

  series.sort((a, b) => a.x - b.x);
  return series;
});

function toPlainSeries() {
  return processedSeries.value.map((p) => ({
    x: Number(p.x),
    y: (p.y === null ? null : Number(p.y)),
  }));
}

function destroyChart() {
  if (chartInstance.value) {
    chartInstance.value.destroy();
    chartInstance.value = null;
  }
}

async function recreateChart() {
  await nextTick();
  if (!chartCanvas.value) return;
  if (!processedSeries.value.length) {
    destroyChart();
    return;
  }

  // ricrea sempre: più stabile su cambi range/metric
  destroyChart();

  const dataSeries = toPlainSeries();
  // console.log("[Chart] timeRange props:", props.timeRange);
  // console.log("[Chart] first/last data:", dataSeries[0]?.x, dataSeries[dataSeries.length-1]?.x);
  // console.log("[Chart] last API point:", dataSeries[dataSeries.length-1]?.x, new Date(dataSeries[dataSeries.length-1]?.x).toISOString());

  const tr = props.timeRange;
  const xMin = tr?.start != null ? tr.start * 1000 : undefined;
  const xMax = tr?.end != null ? tr.end * 1000 : undefined;

  let enriched = [...dataSeries];

  // 1) se vogliamo riempire a 0 prima del primo dato reale
  if (xMin != null && enriched.length) {
    const firstX = Number(enriched[0].x);

    // se il primo dato arriva DOPO xMin, genera zeri tra xMin e firstX
    if (firstX > xMin) {
      // scegli uno step coerente col range (esempi sensati)
      const step =
        props.range === "1h"  ? 60 * 1000 :       // 1 min
        props.range === "24h" ? 5 * 60 * 1000 :   // 5 min
        props.range === "7d"  ? 60 * 60 * 1000 :  // 1h
        props.range === "30d" ? 6 * 60 * 60 * 1000 : // 6h
        60 * 60 * 1000;

      for (let t = xMin; t < firstX; t += step) {
        enriched.push({ x: t, y: 0 });
      }
    }
  }

  // aggiungi sentinelle SOLO se hai un timeRange valido
  if (xMin != null && !enriched.some(p => Number(p.x) === Number(xMin))) {
    enriched.push({ x: xMin, y: null });
  }
  if (xMax != null && !enriched.some(p => Number(p.x) === Number(xMax))) {
    enriched.push({ x: xMax, y: null });
  }

  // ordina dopo insert
  enriched.sort((a, b) => Number(a.x) - Number(b.x));

  const options: any = markRaw({
    responsive: true,
    maintainAspectRatio: false,
    animation: { duration: 0 },
    parsing: false,
    spanGaps: false,
    normalized: true,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        enabled: true,
        mode: "index",
        intersect: false,
        callbacks: {
          // label: (ctx: any) => `${getMetricLabel(props.metric)}: ${ctx.parsed.y}`,
          label: (ctx: any) => {
            const y = ctx.parsed?.y;
            if (y === null || y === undefined) return `${getMetricLabel(props.metric)}: N/D`;
            return `${getMetricLabel(props.metric)}: ${y}`;
          },
        },
      },
      zoom: {
        zoom: {
          wheel: { enabled: true, modifierKey: "alt", speed: 0.1 },
          pinch: { enabled: true },
          mode: "x",
        },
        pan: {
          enabled: true,
          mode: "x",
          modifierKey: "shift",
        },
        // limits: {
        //   x: { min: "original", max: "original" },
        //   y: { min: "original", max: "original" },
        // },
        limits: {
          x: {
            min: xMin ?? "original",
            max: xMax ?? "original",
          },
          y: { min: "original", max: "original" },
        },
      },
    },
    scales: {
      x: {
        type: "timeseries",
        min: xMin,
        max: xMax,
        bounds: "ticks",
        time: {
          unit: (props.range === "1h" ? "minute" : props.range === "24h" ? "hour" : "day"),
          tooltipFormat: "dd/LL/yyyy HH:mm",
        },
        // time: { tooltipFormat: "dd/LL/yyyy HH:mm" },
        ticks: { autoSkip: true, includeBounds: true, maxTicksLimit: 10, color: "#9fb0c2" },
        grid: { display: false },
        title: { display: true, text: "Tempo", color: "#c9d3de" },
      },
      y: {
        beginAtZero: props.metric !== "temperature",
        ticks: { color: "#9fb0c2" },
        grid: { color: "rgba(255,255,255,0.08)" },
        title: { display: true, text: getMetricLabel(props.metric), color: "#c9d3de" },
      },
    },
  });

  const chart = new Chart(chartCanvas.value, {
    type: "line",
    data: {
      datasets: [
        {
          label: getMetricLabel(props.metric),
          data: enriched,
          borderColor: "#4caf50",
          backgroundColor: "rgba(76, 175, 80, 0.12)",
          borderWidth: 2,
          fill: true,
          tension: 0.35,
          pointRadius: 0,
          pointHitRadius: 10,
        },
      ],
    },
    options,
  });

  // console.log("[Chart scale] x.min/x.max (ms):", chart.scales.x.min, chart.scales.x.max);
  // console.log("[Chart scale] x.min/x.max (iso):",
  //   new Date(chart.scales.x.min).toISOString(),
  //   new Date(chart.scales.x.max).toISOString()
  // );
  // console.log("[Chart wanted] xMin/xMax (iso):",
  //   xMin ? new Date(xMin).toISOString() : null,
  //   xMax ? new Date(xMax).toISOString() : null
  // );

  chartInstance.value = markRaw(chart);
}

// Mount
onMounted(async () => {
  if (!props.loading) {
    await recreateChart();
  }
});

onBeforeUnmount(() => {
  if (hintTimeout) clearTimeout(hintTimeout);
  destroyChart();
});

/**
 * Trigger principali:
 * - quando finisce il loading (tipico cambio range: loading true -> false)
 * - quando cambiano data/metric/range/vin
 *
 * NB: ascolto anche vin perché spesso cambia insieme al range e conviene ripulire tutto.
 */
watch(
  () => props.loading,
  async (isLoading) => {
    if (!isLoading) {
      await recreateChart();
    } else {
      // opzionale: mentre carica, evita interazioni strane
      destroyChart();
    }
  },
  { flush: "post" }
);

watch(
  () => [props.metric, props.range, props.vin],
  async () => {
    // range/metric cambiano spesso prima che arrivino i dati:
    // se stai caricando, ci penserà il watcher di loading a ricreare.
    if (!props.loading) {
      await recreateChart();
    }
  },
  { flush: "post" }
);

watch(
  () => props.data,
  async () => {
    // se il parent rimpiazza l’array, questo scatta sicuro
    if (!props.loading) {
      await recreateChart();
    }
  },
  { deep: false, flush: "post" }
);
</script>

<style scoped>
.historical-chart {
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #1a1a1a;
  border-radius: 8px;
  overflow: hidden;
}

.chart-loading {
  flex: 1;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #aaa;
  font-size: 16px;
  padding: 20px;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #333;
  border-top: 4px solid #4caf50;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 16px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.chart-container {
  flex: 1;
  position: relative;
  padding: 20px;
  min-height: 400px;
}

.chart-empty-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #aaa;
  font-size: 16px;
  padding: 40px;
  background: rgba(26, 26, 26, 0.55);
  backdrop-filter: blur(2px);
  pointer-events: none;
}

.chart-info {
  display: flex;
  justify-content: space-around;
  padding: 16px 20px;
  background: #222;
  border-top: 1px solid #333;
}

.info-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.info-label {
  font-size: 12px;
  color: #aaa;
}

.info-value {
  font-size: 14px;
  color: white;
  font-weight: bold;
}

/* Zoom hint overlay */
.zoom-hint-overlay {
  position: absolute;
  inset: 0;
  pointer-events: none;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 16px;
  opacity: 0;
  transition: opacity 0.15s ease;
}

.zoom-hint-overlay.show {
  opacity: 1;
}

.zoom-hint-content {
  background: rgba(0, 0, 0, 0.55);
  border: 1px solid rgba(255,255,255,0.12);
  color: #c9d3de;
  padding: 10px 12px;
  border-radius: 10px;
  font-size: 13px;
  backdrop-filter: blur(3px);
  display: inline-flex;
  gap: 10px;
  align-items: center;
}

.zoom-hint-content kbd {
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.12);
  padding: 2px 6px;
  border-radius: 6px;
  font-size: 12px;
  color: #fff;
}

.hint-sub {
  opacity: 0.8;
}
</style>
